import EquipmentCardView from './EquipmentCardView'
import VisualizationTable from './VisualizationTable'
import equipmentView from '../container/equipmentView'

function EquipmentView() {
  const {
    equipmentLoader,
    loader,
    formData,
    equipmentInfoAPI,
    equipmentData,
    pieChartData,
    buildingEquipmentDetails,
    currentSelectedType,
    brandTotal,
    handleSelect,
    handleClear,
    handleSearch,
  } = equipmentView()

  return (
    <div className="d-flex">
      <VisualizationTable
        {...{
          formData,
          buildingEquipmentDetails,
          equipmentInfoAPI,
          loader,
          handleSelect,
          handleClear,
          handleSearch,
        }}
      />
      <div className="card ml-15 field-equipment-card-main">
        <EquipmentCardView
          {...{
            equipmentLoader,
            equipmentData,
            pieChartData,
            buildingEquipmentDetails,
            currentSelectedType,
            brandTotal,
          }}
        />
      </div>
    </div>
  )
}

export default EquipmentView
